import {ReactElement} from 'react';
import styled from 'styled-components';
import {buttonPill, mediaQueries} from '@theme/lib';

export const StyledPill = styled.div`
  ${buttonPill}
  display: inline-flex;
  align-items: center;

  position: relative;
  min-width: auto;
  max-width: none;
  padding: 1.094rem 2.438rem 0.969rem 1rem;

  ${mediaQueries.lg} {
    padding: 1.094rem 2.438rem 0.969rem 1rem;
  }

  svg {
    position: absolute;
    right: 1rem;
  }
`;

export type Props = {
  title: string;
  onClick: (item: string) => void;
  isButton?: boolean;
};

export default function Pill({
  title,
  onClick,
  isButton,
}: Props): ReactElement<any> {

  return (
    <StyledPill as={isButton ? 'button' : 'div'} type={isButton ? 'button' : undefined} onClick={() => onClick(title)}>
      {title}
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M10.9757 0.511511C11.3244 0.16283 11.8898 0.16283 12.2384 0.511511C12.5871 0.860192 12.5871 1.42552 12.2384 1.7742L7.51266 6.49997L12.2384 11.2257C12.5871 11.5744 12.5871 12.1398 12.2384 12.4884C11.8898 12.8371 11.3244 12.8371 10.9757 12.4884L6.24997 7.76266L1.5242 12.4884C1.17552 12.8371 0.610191 12.8371 0.261511 12.4884C-0.0871706 12.1398 -0.0871706 11.5744 0.261511 11.2257L4.98729 6.49997L0.261511 1.7742C-0.08717 1.42552 -0.08717 0.860192 0.261511 0.511511C0.610192 0.16283 1.17552 0.16283 1.5242 0.511511L6.24997 5.23729L10.9757 0.511511Z" />
      </svg>
    </StyledPill>
  );
}
